import { lazyAddLandmarkKeyboardNavigation } from 'owa-mail-landmarks';
export default async function() {
    (await lazyAddLandmarkKeyboardNavigation.import())();
}
